<template>
  <div class="dialog-content">
    <div class="dialog-content-body">
      <div class="dialog-content-body-title">
        <h1>{{rowExamName}}</h1>
      </div>
      <div class="dialog-content-body-test" v-for="(item,index) in answerExamtPaperTests" :key="index">
        <div class="dialog-content-body-test-title">
          <span class="redismust" v-if="item.is_must == '1'" style="color: red;margin-right: 5px">*</span>
          <p>{{item.sort}}、{{item.case_problem}}</p>
        </div>
        <div class="dialog-content-body-test-answer" v-for="(answer,indexItem) in item.choose_list" :key="indexItem">
          <p>{{answer.value}}、{{answer.text}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    //列表字段
    answerExamtPaperTests:{
      type:Array,
      default:function() {
        return [];
      }
    },
    rowExamName:{
      type:String,
      default:""
    }
  },
  data() {
    return {};
  },
  methods: {
  },
  created(){
  },
  computed:{
  }
};
</script>

<style lang='scss' scoped>
  ::v-deep .el-scrollbar__wrap {
    overflow: scroll-y;
    overflow-x: hidden;
    height:680px;
  }
  ::v-deep .el-card__body{
    padding: 0px 0px 0px 0px;
  }
  ::v-deep .el-card__header{
    height: 61px !important;
  }
  .dialog-content {
    height: 100%;
    width: 100%;
    padding: 0px 24px !important;
    background-color: rgb(255, 255, 255);
    .dialog-content-body{
      display: flex;
      flex-flow: column nowrap;
      height: 100%;
      width: 100%;
      .dialog-content-body-title{
        font-size: 20px;
        width: 100%;
        text-align: center;
        margin-bottom: 20px;
      }
      .dialog-content-body-test{
        width: 100%;
        margin-bottom: 20px;
        .dialog-content-body-test-title{
          position: relative;
          display: flex;
          margin-bottom: 10px;
          font-size: 16px;
          .redismust{
            position: absolute;
            left: -10px;
          }
        }
        .dialog-content-body-test-answer{
          margin-bottom: 10px;
          margin-left: 10px;
          font-size: 16px;
        }
      }
    }
  }

</style>
